import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { Box, TextInput, Text, Button, Layer, DateInput, FormField, CheckBox, Calendar as GrommetCalendar } from 'grommet';
import { Calendar as GrommetIconsCalendar } from "grommet-icons";
import './EditKitSidebar.css';
import close from "../../../../../../assets/close_small (1).svg";
import MedicalKitService from '../../../../../../services/medical-kit/medical-kit.service';
import { useStore } from '../../../../../../Hooks/useStore';
import checkboxUnchecked from '../../../../../../assets/tick-square.svg';
import checkboxChecked from '../../../../../../assets/tick-square.svg';
import Pagination from './PaginationS';
import { observer } from 'mobx-react';
import { Mixpanel } from '../../../../../../util/Helper';
import YearSelection from '../../EMS/common/YearSelection/YearSelection';

const EditMedicalKit = observer(({ onClose }) => {
  const [kitData, setKitData] = useState({
    flightNumber: '',
    expiryDate: '',
  });
  const [selectedItems, setSelectedItems] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [sorted, setSorted] = useState([]);
  const [isOthersChecked, setIsOthersChecked] = useState(false);
  const [othersValue, setOthersValue] = useState('');
  const [isAnyCheckboxSelected, setIsAnyCheckboxSelected] = useState(false);
  const [openCalender, setOpenCalender] = useState(false)
  const itemsPerPage = 10;
  const totalItems = sorted.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const { rootStore } = useStore();

  const [ kitSelectedItem, setKitSelectedItem ] = useState([]);

  useEffect(() => {
    setKitData({
      flightNumber: rootStore.medicalKitStore.getFlightNo,
      expiryDate: rootStore.medicalKitStore.getExpiry,
    });
  }, [rootStore.medicalKitStore.getFlightNo, rootStore.medicalKitStore.getExpiry]);

  const getCreateKit = async () => {
    try {
      const ItemData = await MedicalKitService.getCreateKit();
      rootStore.medicalKitStore.handlemedicallist(ItemData);
      setSorted(ItemData);

      // Initialize selected items with default checked values
      const initialSelectedItems = ItemData.reduce((acc, item) => {
        acc[item.id] = item.defaultChecked || false; // Adjust based on your data
        return acc;
      }, {});
      setSelectedItems(initialSelectedItems);

    } catch (error) {
      console.error('Error fetching medical kits:', error);
    }
  };

  useEffect(() => {
    getCreateKit();
  },[])
  const handleChangeFlightNumber = (event) => {
    rootStore.medicalKitStore.handleFlightTailNo(event.target.value);
  };

  const handleChangeExpiryDate = ({ value }) => {
    rootStore.medicalKitStore.handleDate(value);
  };

  const handleCheckBoxChange = (item) => {
    rootStore.medicalKitStore.handleKitSelectedItem({id: item.id, name: item.name});

    rootStore.medicalKitStore.handleItem();

    const newSelectedItems = {
      ...selectedItems,
      [item.id]: !selectedItems[item.id],
    };
    setSelectedItems(newSelectedItems);

    const anySelected = Object.values(newSelectedItems).some(isSelected => isSelected);
    setIsAnyCheckboxSelected(anySelected);

    if (newSelectedItems[item.id]) {
      rootStore.medicalKitStore.setItems(item.id);
    } else {
      rootStore.medicalKitStore.removeItem(item.id);
    }
  };


  const handleOthersChange = (e) => {
    setOthersValue(e.target.value);
  };

  const handleOthersCheckboxChange = () => {
    setIsOthersChecked(!isOthersChecked);
  };

  const handleAddOthers = () => {
    if (isOthersChecked && othersValue.trim()) {
      const newItem = {
        id: "",
        name: othersValue,
        photoUrl: null,
        photoName: null
      };
      setSorted([...sorted, newItem]);
      setSelectedItems({ ...selectedItems, [newItem.id]: false });
      setOthersValue('');
      setIsOthersChecked(false);
    }
  };

  // const handleSave = async () => {

  //   await MedicalKitService.getAddCreateKit(
  //     rootStore.medicalKitStore.getMedicalKitId,
  //     rootStore.medicalKitStore.getDate,
  //     rootStore.medicalKitStore.getFlightTailNo,
  //     rootStore.medicalKitStore.getKitSelectedItem
  //   )
  //     .then(() => {
  //       rootStore.notificationToastStore.showNotification(
  //         "Kit saved successfully",
  //         false,
  //         3000
  //       );
  //       rootStore.medicalKitStore.handleupdates()

  //     })
  //     .catch(() => {
  //       rootStore.notificationToastStore.showNotification(
  //         "Failed to save kit",
  //         true,
  //         3000
  //       );
  //     });
  // };
  const handleSave = async () => {
    await MedicalKitService.getAddCreateKit(
      rootStore.medicalKitStore.getMedicalKitId,
      rootStore.medicalKitStore.getDate,
      rootStore.medicalKitStore.getFlightTailNo,
      rootStore.medicalKitStore.getKitSelectedItem
    )
      .then(() => {
        rootStore.notificationToastStore.showNotification(
          "Kit saved successfully",
          false,
          3000
        );
        rootStore.medicalKitStore.handleupdates();
      })
      .catch(() => {
        rootStore.notificationToastStore.showNotification(
          "Failed to save kit",
          true,
          3000
        );
      })
      .finally(() => {
        // Code to run regardless of success or failure
        // For example, you might want to close a modal or reset form fields here
        onClose(); // Replace with your actual function or logic
      });
  };


  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
      await MedicalKitService.updateKitEdit(
        kitData.expiryDate,
        kitData.flightNumber,
        rootStore.medicalKitStore.getItems
      );
      rootStore.notificationToastStore.showNotification("Kit updated successfully", false, 3000);
      rootStore.flightsStore.handleupdate();
    } catch (error) {
      console.error('Error updating kit:', error);
      rootStore.notificationToastStore.showNotification("Failed to update kit. Please try again later.", true, 3000);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sorted.slice(indexOfFirstItem, indexOfLastItem);
  const showOthersSection = (currentPage === totalPages || (currentPage < totalPages && sorted.slice(indexOfLastItem).length === 0));

  const resetMedicalKit = async () => {
    try {
      const MedicalResponse = await MedicalKitService.getEditKit(rootStore.medicalKitStore.getMedicalKitId);
      const finalreponse = MedicalResponse[0];
      rootStore.medicalKitStore.handleDate(finalreponse.medicalKit.expiryDate);
      rootStore.medicalKitStore.handleFlightTailNo(finalreponse.medicalKit.flight);
      rootStore.medicalKitStore.handleItem(MedicalResponse);
      rootStore.medicalKitStore.resetKitSelectedItem()
      MedicalResponse.map((kit) => {
        rootStore.medicalKitStore.handleKitSelectedItem({ id: kit.item.id, name: kit.item.name });
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleIconClick = ()=>{
    setOpenCalender(!openCalender)
  }

  const onYearSelected = useCallback((year) => {
    rootStore.emsStore.setYearSelected(year);
    rootStore.emsStore.handleYearSelectionShow();
    const newDate = new Date(year, rootStore.emsStore.getMonthSelected, 1);
    rootStore.medicalKitStore.handleDate(newDate);
  }, []);
  
  const onMonthSelected = useCallback((month) => {
    rootStore.emsStore.setMonthSelected(month);
    rootStore.emsStore.handleYearSelectionShow();
    const newDate = new Date(rootStore.emsStore.getSelectedYear, month, 1);
    rootStore.medicalKitStore.handleDate(newDate);
  }, []);
  
  
  

  const handleTextClick = () => {
    rootStore.emsStore.handleYearSelectionShow();
  }

  useLayoutEffect(() => {
    const textElement = document.querySelector('.calendar-customize h3');
    if (textElement) {
      textElement.addEventListener('click', handleTextClick);
    }
    return () => {
      if (textElement) {
        textElement.removeEventListener('click', handleTextClick);
      }
    };
  }, [handleTextClick]);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  return (
    <Layer
      className='outer'
      full="vertical"
      position="right"
      onClickOutside={onClose}
      onEsc={onClose}
      style={{ borderRadius: "12px 0 0 12px", zIndex: 1000, width: "700px" }}
    >
      <Box className="edit-kit-sidebar" background="light-1" elevation="medium" pad="medium" fill="vertical">
        <div className="edit-kit-header-container">
          <div className="header" style={{padding: 0}}>
            <Box>
              <Text className="title">Edit Kit</Text>
              <p className="description">**Please fill out the details for the new kit.**</p>
            </Box>
            <Button
              className="close-btn"
              onClick={onClose}
            >
              <img src={close} alt="close" />
              Close
            </Button>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <form onSubmit={handleSubmit} style={{ display: "flex", gap: "30px", justifyContent: "space-between", width: "100%" }}>
            <FormField name="flightNumber" className='mt-17 label'>
              <label className='labels'>Flight Number</label>
              <TextInput
                className='input-style'
                placeholder='Enter flight number'
                value={rootStore.medicalKitStore.getFlightTailNo}
                onChange={handleChangeFlightNumber}
              />
            </FormField>
            {/* <FormField className='mt-17 label' required>
              <label className='labels'>Select Expiry Date</label>
              <DateInput
                className='input-style'
                format="mm/dd/yyyy"
                placeholder='Select expiry date'
                value={rootStore.medicalKitStore.getDate}
                onChange={handleChangeExpiryDate}
              />
            </FormField> */}
            <FormField 
                name="expiryDate" 
                className='mt-17 label' 
                // htmlFor="expiryDate-id" 
                required 
                style={{ position: 'relative' }}
              >
                <label className="labels">Select Expiry Date</label>
                <div className="input-container" style={{ position: "relative" }}>
                  <TextInput 
                    className="input-style" 
                    id="expiryDate-id" 
                    name="expiryDate" 
                    placeholder="Select expiry date" 
                    value={rootStore.medicalKitStore.getDate? formatDate(rootStore.medicalKitStore.getDate):""}
                    onChange={handleChangeExpiryDate} 
                    style={{ border: "none" }}
                  />
                  <div 
                    className="icon-container" 
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor:"pointer"
                    }} 
                    onClick={handleIconClick}
                  >
                    <GrommetIconsCalendar />
                  </div>
                </div>
                {openCalender && (
                  <div 
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      zIndex: 1,
                      backgroundColor: "white",
                      padding: "20px",
                      width:"100%",
                      borderRadius:'16px',
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)"
                    }}
                  >
                    {
                      rootStore.emsStore.getYearSelection
                      &&
                      <YearSelection
                        onYearSelected={onYearSelected}
                        onMonthSelected={onMonthSelected}
                        selectedYear={rootStore.emsStore.getSelectedYear}
                      />
                    }
                    <GrommetCalendar 
                      className="calender calendar-customize" 
                      size="medium" 
                      // date={rootStore.emsStore.getSelectedDate} 
                      // date={new Date(rootStore.emsStore.getSelectedYear, rootStore.emsStore.getSelectedMonth, 1)}
                      date={new Date(rootStore.emsStore.getSelectedYear, rootStore.emsStore.getSelectedMonth, 1, 12)}
                      onSelect={(date) => {
                        rootStore.medicalKitStore.handleDate(date);
                        rootStore.emsStore.setSelectedDate(date);
                        rootStore.emsStore.handleIsDateSelect();
                        handleIconClick()
                      }} 
                      animate={true} 
                      fill={true} 
                      daysOfWeek={true}                  
                    />
                  </div>
                )}
              </FormField>
          </form>
        </div>
        <div className='select-kit'>Select Kit</div>
        <div className="data-table-container">
          <div className="grid-container">
            {currentItems.map((item) => (
              <div className="grid-item" key={item.id}>
                <CheckBox
                  checked={rootStore.medicalKitStore.getKitSelectedItem.map((kit) => kit.id).includes(item.id)}
                  onChange={() => handleCheckBoxChange(item)}
                  aria-label={`Select ${item.name}`}
                  style={{
                    padding: 0,
                    marginRight: '10px',
                    height: '20px',
                    width: '20px',
                    backgroundImage: `url(${selectedItems[item.id] ? checkboxChecked : checkboxUnchecked})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    border: 'none'
                  }}
                />
                {item.name}
              </div>
            ))}
          </div>
          {showOthersSection && (
            <div className="others-section" style={{ display: "flex", alignItems: "center", marginTop: '20px' }}>
              <CheckBox
                checked={isOthersChecked}
                onChange={handleOthersCheckboxChange}
                aria-label="Others checkbox"
                style={{
                  padding: 0,
                  marginRight: '10px',
                  width: '20px',
                  backgroundImage: `url(${isOthersChecked ? checkboxChecked : checkboxUnchecked})`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  border: 'none'
                }}
              />
              <span style={{ color: "#41454B", fontFamily: "Inter", fontSize: "14px", fontStyle: "normal", fontWeight: "500", lineHeight: "16px" }}>Others</span>
              <input
                type="text"
                value={othersValue}
                onChange={handleOthersChange}
                disabled={!isOthersChecked}
                placeholder='Enter here'
                style={{
                  width: "280px",
                  height: "38px",
                  padding: "4px 4px 4px 15px",
                  borderRadius: "10px",
                  background: "#F2F8FF",
                  border: "unset"
                }}
              />
              <Button
                label="Add"
                onClick={handleAddOthers}
                style={{
                  marginLeft: '10px',
                  padding: '4px 12px',
                  background: '#357EFF',
                  color: '#FFF',
                  borderRadius: '6px',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: '600'

                }}
              />
            </div>
          )}

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={totalItems}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
        <div className='btn-outer'>
          <Button
            className='reset'
            type="reset"
            label="Reset"
     
            onClick={() => {
              resetMedicalKit();
              setKitData({ flightNumber: '', expiryDate: '' });
              setSelectedItems(Object.keys(selectedItems).reduce((acc, id) => {
                acc[id] = false;
                return acc;
              }, {}));
              setIsOthersChecked(false);
              setOthersValue('');
            }}
            style={{
              display: 'flex',
              width: '120px',
              padding: '14px 49px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              borderRadius: '10px',
              background: '#357EFF',
              color: '#FFF',
              fontFamily: 'Inter',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '24px'
            }}
          />
          <Button
            className='save'
            type="submit"
            // label={isAnyCheckboxSelected ? "Save" : "Create"}
            label="Save"
            onClick={handleSave}
            style={{
              display: 'flex',
              width: '120px',
              marginLeft: "10px",
              padding: '14px 49px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              borderRadius: '10px',
              background: '#357EFF',
              color: '#FFF',
              fontFamily: 'Inter',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '24px'
            }}
          />
        </div>
      </Box>
    </Layer>
  );
});

export default EditMedicalKit;
